import { useMemo } from "react";

import { ColumnDef } from "@tanstack/react-table";
import { ChevronRightIcon } from "@digital-services-gard-as/anchor-icons";

import { Button } from "@digital-services-gard-as/anchor-react";
import { InvoiceTableDataDto } from "@/api/invoiceApi";
import { useTranslation } from "react-i18next";

import { HierarchicalDto } from "@/api/usersApi";
import { tableText } from "../../../table/utils";

const NAVIGATION_CELL_SIZE = 3;

export function useColumns(branchCompanies?: HierarchicalDto) {
    const { t } = useTranslation("claimsInvoicesOverview");
    return useMemo<ColumnDef<InvoiceTableDataDto>[]>(
        () => [
            {
                header: t("draftInvoicesTab.Table.invoiceDate"),
                accessorKey: "invoiceDate",
                enableSorting: true,
                enableHiding: false,
                sortDescFirst: true
            },
            {
                header: t("draftInvoicesTab.Table.invoiceDueDate"),
                accessorKey: "invoiceDueDate",
                enableSorting: true,
                enableHiding: false,
                sortDescFirst: true
            },
            {
                header: t("draftInvoicesTab.Table.invoiceReference"),
                id: "invoiceReference",
                accessorKey: "invoiceReference",
                cell: tableText("invoiceReference"),
                enableSorting: true,
                enableHiding: false,
                sortDescFirst: true
            },
            {
                header: t("draftInvoicesTab.Table.subClaimsRef"),
                accessorKey: "subClaimsRef",
                cell: tableText("subClaimsRef"),
                enableSorting: true,
                enableHiding: false,
                sortDescFirst: true
            },
            {
                header: t("draftInvoicesTab.Table.incidentDate"),
                accessorKey: "incidentDate",
                cell: tableText("incidentDate"),
                enableSorting: true,
                enableHiding: false,
                sortDescFirst: true
            },
            {
                header: t("draftInvoicesTab.Table.vessel"),
                accessorKey: "vessel",
                cell: tableText("vessel"),
                enableSorting: true,
                enableHiding: false,
                sortDescFirst: true
            },
            {
                header: t("draftInvoicesTab.Table.branchCompany"),
                accessorFn: row => {
                    const branchCompanyCrmId = row.branchCompany;
                    const branchCompany = branchCompanies?.children?.find(
                        branch => branch.crmId?.toString() === branchCompanyCrmId
                    );
                    return branchCompany ? branchCompany.companyName : "";
                },
                accessorKey: "branchCompany",
                cell: tableText("branchCompany"),
                enableSorting: true,
                enableHiding: true,
                sortDescFirst: true
            },
            {
                header: t("draftInvoicesTab.Table.totalInvoiceAmount"),
                accessorKey: "totalInvoiceAmount",
                cell: tableText("totalInvoiceAmount"),
                enableSorting: false,
                enableHiding: false
            },
            {
                header: () => null,
                id: "navigation",
                cell: ({ row }) => (
                    <Button
                        id={"navigateDraftInvoiceBtn" + row.id}
                        aria-label="Open invoice"
                        icon={<ChevronRightIcon />}
                        variant="icon-only"
                    />
                ),
                size: NAVIGATION_CELL_SIZE,
                enableHiding: false
            }
        ],
        [t, branchCompanies]
    );
}
